<template>
  <div>
    <v-select
      :items="filteredStatusList"
      item-text="description"
      item-value="id"
      item-disabled="disabled"
      return-object
      v-model="content"
      :label="label"
      @input="handleSelection"
      @click:clear="handleSelection"
      clearable
    >
      <template v-slot:items="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-tile-content v-text="data.item.description"></v-list-tile-content>
        </template>

      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "StatusSelector",
  props: ['label', 'statusList', 'value', 'selectedCollection'],
  data() {
    return {
      content: this.value
    }
  },
  methods: {
    handleSelection(event) {
      const selection = (this.content !== null && typeof this.content.id !== "undefined") ? this.content.id.toString() : '';
      this.$emit('input', selection);
    }
  },
  computed: {
    filteredStatusList() {
      const filteredList = [];
      const selectedCollectionKeys = Object.keys(this.selectedCollection);
      for (let i = 0; i < this.statusList.length; i++) {
        let statusObj = this.statusList[i];
        statusObj.disabled = false;

        for (let i = 0; i < selectedCollectionKeys.length; i++) {
          if (parseInt(selectedCollectionKeys[i]) === parseInt(statusObj.id)) {
            statusObj.disabled = true;
            continue;
          }
        }

        filteredList.push(statusObj);
      }

      return filteredList;
    }
  }
}
</script>

<style scoped>

</style>
